import { paths } from "render/routes/paths";

/**
 * True for any screen inside a member's check-in journey. `StepFlow` uses it to
 * stop the active-session mark riding out to the home screen, where the next
 * member's check-in run would inherit it (AB#90956).
 */
export function isCheckInUrl(url: string): boolean {
  const [pathname] = url.split("?");

  return paths.checkIn.parse(pathname) != null;
}
